export const BUTTON_SIZE = 64
/* Play area image will be scaled to device size.
   Here it's initial aspect ratio.
*/
export const PLAY_AREA_WIDTH = 628
export const PLAY_AREA_HEIGHT = 577
